export default __webpack_public_path__ + "static/media/benefit_15@3x.a31869aa.png";